import React from 'react'
import { BrowserView, MobileView } from 'react-device-detect'
import {
  faCheck,
  faClose,
  faEquals,
  faMultiply,
  faPencilAlt,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'

import { ProductImage } from 'app/common/Common'
import {
  $DCprimaryColor,
  Link,
  PixelCurrency,
  PixelDiv,
  PixelFactoryContext,
  PixelIcon,
} from 'pixel-base'
import styled, { css } from 'styled-components'
import { deleteProduct, updateProductsQuantity } from 'utils/api-routes.util'

import PriceContainer from './common/PriceContainer'
import QuantityContainer from './common/QuantityContainer'
import ItemProperty from './ItemProperties'
import { LineItem, OrderDetail, IPixelFactory } from '../../../../../../decl.d'

export interface IProperties {
  odp_id: string
  image_path: string
  property_name: string
  property_type: string
  property_value: string
  order_detail_id: string
}

interface IProps {
  item: LineItem
  setDetails: (details: OrderDetail) => void
  detailID: string
  data: OrderDetail
  setData: (data: OrderDetail) => void
  complaintSection: boolean
  details: OrderDetail
  newOrder: boolean
  newOrderData: OrderDetail
  setNewOrderData: (newOrderData: OrderDetail) => void
  size: string
  showOrderMark: boolean
}
const ProductLineItem = (props: IProps) => {
  const {
    item,
    setDetails,
    detailID,
    data,
    setData,
    complaintSection,
    details,
    newOrder,
    newOrderData,
    setNewOrderData,
    size,
    showOrderMark,
  } = props

  const [itemProperties, setItemProperties] = React.useState([])
  const [isEditable, setIsEditable] = React.useState(false)
  React.useEffect(() => {
    setItemProperties(item?.properties)
  }, [item])
  React.useEffect(() => {
    if (newOrder) {
      setIsEditable(true)
    }
  }, [])
  const { showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [newProductQuantity, setNewProductQuantity] = React.useState<{
    line_item_id: string
    price: string
    quantity: string
  }>({
    line_item_id: '',
    price: '',
    quantity: '',
  })

  const handleProductQuantity = (detailID, newProductQuantity, productId) => {
    if (complaintSection === true) {
      setData({
        ...data,
        exchange_products: data.exchange_products.map((item) => {
          if (item.product_id === productId) {
            return {
              ...item,
              quantity: newProductQuantity.quantity,
              price: newProductQuantity.price,
            }
          }
          return item
        }),
      })
      setIsEditable(false)
    } else {
      if (newOrder === true) {
        setNewOrderData({
          ...newOrderData,
          line_items: newOrderData?.line_items?.map((item) => {
            if (item.product_id === productId) {
              return {
                ...item,
                quantity: newProductQuantity.quantity,
                price: newProductQuantity.price,
              }
            }
            return item
          }),
        })
        setIsEditable(false)
      } else {
        showPageLoader()
        updateProductsQuantity(detailID, newProductQuantity).subscribe(
          (res: any) => {
            hidePageLoader()
            if (res.response.data) {
              setDetails(res.response.data)
              setIsEditable(false)
            } else {
              showFailure(res.response.error)
            }
          },
        )
      }
    }
  }

  const handleDelete = (detailID, product_id, productID) => {
    if (complaintSection === true) {
      setData({
        ...data,
        exchange_products: data.exchange_products.filter(
          (key) => key.product_id !== productID,
        ),
      })
    } else {
      if (newOrder === true) {
        setNewOrderData({
          ...newOrderData,
          line_items: newOrderData?.line_items?.filter(
            (key) => key.product_id !== productID,
          ),
        })
      } else {
        showPageLoader()
        deleteProduct(detailID, product_id).subscribe((res: any) => {
          hidePageLoader()
          setDetails(res.response.data)
        })
      }
    }
  }

  React.useEffect(() => {
    setNewProductQuantity({
      line_item_id: item.line_item_id,
      price: item.price,
      quantity: item.quantity,
    })
  }, [item])

  const TotalContainer = () => (
    <Total>
      <InlineSection>
        <PixelCurrency
          value={(
            newProductQuantity.price * newProductQuantity.quantity
          ).toFixed(2)}
        />
      </InlineSection>
    </Total>
  )

  const ActionsContainer = () => (
    <>
      {complaintSection ? (
        <Actions>
          {isEditable ? (
            <>
              <Link
                showTooltip
                tooltip="Update"
                onClick={() => {
                  handleProductQuantity(
                    detailID,
                    newProductQuantity,
                    item.product_id,
                  )
                }}
                decoration
              >
                <PixelIcon
                  showTooltip
                  tooltip="Update"
                  color={$DCprimaryColor}
                  icon={faCheck}
                />
              </Link>
            </>
          ) : (
            <>
              <Link
                onClick={() => {
                  setIsEditable(true)
                }}
                decoration
              >
                <PixelIcon
                  showTooltip
                  tooltip="Edit"
                  color={$DCprimaryColor}
                  icon={faPencilAlt}
                />
              </Link>
            </>
          )}
          {isEditable ? (
            <>
              <PixelIcon
                showTooltip
                tooltip="Cancel"
                onClick={() => {
                  setIsEditable(false)
                }}
                color={$DCprimaryColor}
                fontSize="1x"
                icon={faClose}
              />
            </>
          ) : (
            <>
              <PixelIcon
                showTooltip
                tooltip="Delete"
                onClick={() => {
                  handleDelete(detailID, item.line_item_id, item.product_id)
                }}
                color="#f00"
                fontSize="1x"
                icon={faTrash}
              />
            </>
          )}
        </Actions>
      ) : (
        <>
          {newOrder ? (
            <>
              {/* ----------------- new order -------------------- */}
              <Actions>
                <PixelIcon
                  showTooltip
                  tooltip="Delete"
                  onClick={() => {
                    handleDelete(detailID, item.line_item_id, item.product_id)
                  }}
                  color="#f00"
                  fontSize="1x"
                  icon={faTrash}
                />
              </Actions>
            </>
          ) : (
            <>
              {details?.is_editable === true && (
                <Actions>
                  {isEditable ? (
                    <>
                      <Link
                        onClick={() => {
                          handleProductQuantity(
                            detailID,
                            newProductQuantity,
                            item.product_id,
                          )
                        }}
                        decoration
                      >
                        <PixelIcon
                          showTooltip
                          tooltip="update"
                          color={$DCprimaryColor}
                          icon={faCheck}
                        />
                      </Link>
                    </>
                  ) : (
                    <>
                      <Link
                        onClick={() => {
                          setIsEditable(true)
                        }}
                        decoration
                      >
                        <PixelIcon
                          showTooltip
                          tooltip="Edit"
                          color={$DCprimaryColor}
                          icon={faPencilAlt}
                        />
                      </Link>
                    </>
                  )}
                  {isEditable ? (
                    <>
                      <PixelIcon
                        showTooltip
                        tooltip="Cancel"
                        onClick={() => {
                          setIsEditable(false)
                        }}
                        color={$DCprimaryColor}
                        fontSize="1x"
                        icon={faClose}
                      />
                    </>
                  ) : (
                    <>
                      <PixelIcon
                        showTooltip
                        tooltip="Delete"
                        onClick={() => {
                          handleDelete(
                            detailID,
                            item.line_item_id,
                            item.product_id,
                          )
                        }}
                        color="#f00"
                        fontSize="1x"
                        icon={faTrash}
                      />
                    </>
                  )}
                </Actions>
              )}
            </>
          )}
        </>
      )}
    </>
  )

  return (
    <div style={{ width: '100%' }}>
      <>
        <InnerSection>
          <BrowserView>
            <MainContainer>
              <ProductContainer
                size={size}
                padding={itemProperties?.length > 0}
                className={isEditable ? 'gap' : ''}
              >
                <Product>
                  {showOrderMark && (
                    <MarkSection>
                      <Mark>{item.orderMark}</Mark>
                    </MarkSection>
                  )}
                  <PixelDiv>
                    <ProductImage
                      style={{
                        width: '38px',
                        height: '38px',
                        marginRight: '5px',
                        marginTop: '5px',
                        borderRadius: '3px',
                        border: '1px solid #e6e6e6',
                      }}
                      path={item.image}
                    />
                  </PixelDiv>
                  <PixelDiv>
                    <ProductName>{item.name}</ProductName>
                    <InlineSection>SKU: {item.sku}</InlineSection>
                  </PixelDiv>
                </Product>
                <Quantity>
                  <QuantityContainer
                    isEditable={isEditable}
                    newProductQuantity={newProductQuantity}
                    newOrder={newOrder}
                    setNewOrderData={setNewOrderData}
                    newOrderData={newOrderData}
                    item={item}
                    setNewProductQuantity={setNewProductQuantity}
                  />
                </Quantity>

                <Price>
                  <PriceContainer
                    isEditable={isEditable}
                    newProductQuantity={newProductQuantity}
                    newOrder={newOrder}
                    setNewOrderData={setNewOrderData}
                    newOrderData={newOrderData}
                    item={item}
                    setNewProductQuantity={setNewProductQuantity}
                  />
                </Price>

                <TotalContainer />
                <ActionsContainer />
              </ProductContainer>
              <PropertiesMainContainer>
                {itemProperties?.map((item: IProperties, index) => {
                  return (
                    <React.Fragment key={index}>
                      <ItemProperty
                        item={item}
                        handleUpdate={(property: IProperties) => {
                          const newProperties = itemProperties.map(
                            (item: IProperties) => {
                              if (item.odp_id === property.odp_id) {
                                return property
                              }
                              return item
                            },
                          )
                          setItemProperties(newProperties)
                        }}
                      />
                    </React.Fragment>
                  )
                })}
              </PropertiesMainContainer>
            </MainContainer>
          </BrowserView>
          <MobileView>
            <MobileRow>
              <Product>
                <PixelDiv>
                  <ProductImage
                    style={{
                      width: '38px',
                      height: '38px',
                      marginRight: '5px',
                      marginTop: '5px',
                      borderRadius: '3px',
                      border: '1px solid #e6e6e6',
                    }}
                    path={item.image}
                  />
                </PixelDiv>
                <PixelDiv>
                  <ProductName>{item.name} </ProductName>
                  <InlineSection>SKU: {item.sku}</InlineSection>
                  <MobileRow isRow>
                    <Price>
                      <PriceContainer
                        isEditable={isEditable}
                        newProductQuantity={newProductQuantity}
                        newOrder={newOrder}
                        setNewOrderData={setNewOrderData}
                        newOrderData={newOrderData}
                        item={item}
                        setNewProductQuantity={setNewProductQuantity}
                      />
                    </Price>
                    <MobileSymbol>
                      <PixelIcon icon={faMultiply} />
                    </MobileSymbol>
                    <Quantity>
                      <QuantityContainer
                        isEditable={isEditable}
                        newProductQuantity={newProductQuantity}
                        newOrder={newOrder}
                        setNewOrderData={setNewOrderData}
                        newOrderData={newOrderData}
                        item={item}
                        setNewProductQuantity={setNewProductQuantity}
                      />
                    </Quantity>

                    <MobileSymbol>
                      <PixelIcon icon={faEquals} />
                    </MobileSymbol>
                    <TotalContainer />
                    <ActionsContainer />
                  </MobileRow>
                </PixelDiv>
              </Product>
            </MobileRow>
          </MobileView>
        </InnerSection>
      </>
    </div>
  )
}

const InnerSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  border-bottom: 1px solid #e6e6e6;
  width: 100%;
  padding: 10px 0px;
`

export const InlineSection = styled.div<{ color?: string }>`
  font-size: 12px;
  font-weight: 400;
  color: ${(props) =>
    props.color === 'primary' ? $DCprimaryColor : 'rgba(0, 0, 0, 0.87)'};
`
export const ProductName = styled.div`
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
`
const MainContainer = styled.div``

const PropertiesMainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 10px;
  padding-left: 20px;
  padding-top: 5px;
`
const ProductContainer = styled.div<{
  justify?: boolean
  isMobile?: boolean
  padding?: boolean
  size?: string
}>`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) =>
    props.justify ? 'flex-start' : 'space-around'};
  align-items: center;
  align-content: center;
  width: 100%;
  padding: ${(props) =>
    props.padding
      ? '15px 15px 0px 15px'
      : props.size === 'sm'
      ? '0px'
      : '15px'};
  padding-bottom: none;
  &.gap {
    gap: 10px;
  }

  ${({ isMobile }) =>
    isMobile &&
    css`
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      align-content: center;
    `}
`

const Product = styled.div`
  display: flex;
  flex-direction: row;
  width: 50%;
  gap: 10px;
`
const Quantity = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 10%;
`
const Price = styled.div<{ justify?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 10%;
`
const Total = styled.div<{ justify?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 10%;
`
const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 15%;
`

const MobileRow = styled.div<{ isRow?: boolean }>`
  flex-direction: ${({ isRow }) => (isRow ? 'row' : 'column')};
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  gap: 15px;
  padding: 10px;
  ${Product} {
    width: 100%;
  }
  ${Quantity}, ${Price}, ${Total}, ${Actions} {
    display: inline-flex;
    width: auto;
    margin-right: 10px;
    gap: 10px;
  }
`
const MobileSymbol = styled.div`
  display: inline-flex;
  margin-right: 10px;
  font-size: 12px;
  font-weight: 400;
`
export const MarkSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  width: 8%;
  &.textSmall {
    width: auto;
    font-size: 12px;
    color: #000;
    font-weight: 500;
    margin-left: 10px;
  }
`
export const Mark = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 1px solid ${$DCprimaryColor};
  color: ${$DCprimaryColor};
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  &.textSmall {
    width: 0px;
    height: 0px;
    padding: 11px;
    margin-right: 5px;
  }
`
export default ProductLineItem
